
import {
  Component,
  AfterContentInit,
  OnDestroy,
  ElementRef
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { CustomFieldDTO } from '../../api/plyca-dtos-v2';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { Configuration } from '../../conf/app.constants';
import { Router } from '@angular/router';
import { PaginationDTO } from '../../api/PaginationModel';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

@Component({
  selector: 'customFieldsPanel',
  templateUrl: 'customFieldsPanel.template.html'
})
export class customFieldsPanelComponent extends BaseComponent
  implements AfterContentInit, OnDestroy {
  loaded = false;
  customFields: CustomFieldDTO[] = [];
  constructor(
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    public uiService: UIService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    protected configuration: Configuration,
    private router: Router
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.CUSTOMFIELDS));
  }

  ngAfterContentInit(): void {
    this.headerActionsService.setTaskDescription(
      this.elem,
      'ControlPanel.customFields.title',
      'fab fa-readme',
      this.isLoaded.bind(this)
    );


    this.subscribe(this.headerActionsService
      .addAction('General.reload', 'fas fa-sync-alt', 'btn-secondary', true),
      () => {
        this.loadCustomFields();
      });


    this.headerActionsService.addDivider();
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , () => {
        this.uiService.routeBack();
      });

    this.loadCustomFields();
  }

  addCustomField() {
    this.router.navigate(['customField', 'new']);
  }

  ngOnDestroy(): void { }

  public isLoaded(): boolean {
    return this.loaded;
  }

  loadCustomFields() {
    this.loaded = false;
    this.subscribe(
      this.plycaService
        .query<CustomFieldDTO>(this.configuration.CUSTOMFIELDS_SERVICE_URL)
      , (result: PaginationDTO<CustomFieldDTO>) => {
        if (result && result.content) {
          this.customFields = result.content;
          if (!this.customFields) {
            this.customFields = [];
          }
        }
        this.loaded = true;
      });
    // this.customFields = [
    //   {
    //     identifier: 'C1',
    //     name: 'C1 name',
    //     description: 'C1 description',
    //     type: CustomFieldTypeDTO.Text,
    //     subType: '',
    //     value: '',
    //     format: '',
    //     enabled: true,
    //     ambito: ''
    //   },
    //   {
    //     identifier: 'C2',
    //     name: 'C2 name',
    //     description: 'C2 description',
    //     type: CustomFieldTypeDTO.Text,
    //     subType: '',
    //     value: '',
    //     format: '',
    //     enabled: true,
    //     ambito: ''
    //   }
    // ];
    // this.loaded = true;
  }

  startCustomFieldEdition(customField: CustomFieldDTO) {
    this.router.navigate(['customField', customField.identifier]);
  }

  getDestination(customField: CustomFieldDTO) {
    if (customField.destination?.attribute?.identifier)
      return 'VALATRIBUTOENT (' + customField.destination?.attribute?.identifier + ')';
    else if (customField.destination?.location?.column && customField.destination?.location?.table)
      return customField.destination.location.table + '.' + customField.destination.location.column;
    else
      return '-';
  }
}
